// extracted by mini-css-extract-plugin
module.exports = {"header":"SectionHeader_header__U_DFJ"};